  <div class="questionnaire-container">
    <true-breadcrumbs [subset]="this.config.subset" [assessmentName]="assessmentName + ' (' + assessmentObject + ')'"></true-breadcrumbs>
    <!-- Business brief Section -->
    <!-- TODO: replace image with interactive document - scroll to view, click to download? -->    
    <div class="questionnaire-layout">
      <div class="questionnaire-image">
        <img src="assets/bmodel.png" alt="Business model" />
      </div>
      <div class="questionnaire-instructions">
        <h2>Detailed Analysis</h2>
        <p>
            The Business Model offers a more comprehensive analysis of the business opportunity. It includes detailed background information, industry context, and specific challenges faced by farms.
        </p>
        <h2>Implementation Focus</h2>
        <p>
            It outlines specific objectives, desired outcomes, and implementation steps, providing a roadmap for putting the business model into practice.
        </p>
        <h2>Risk and Stakeholder Management</h2>
        <p>
            The Business Model addresses risk assessment, stakeholder identification, and engagement strategies, which are not typically covered in the Lean Canvas.
        </p>
      </div>
    </div>
    
    <ng-template [ngIf]="selectedSection">
      <div class="questionnaire-flex-layout section-selection">
        <!-- First Column: Display Selected Section Content -->
        <div class="questionnaire-column">            
          <div class="header-with-actions">
            <h2>Section selection</h2>
            <span class="spacer"></span>
            <button title="Previous section" mat-icon-button aria-label="Undo" (click)="previousSection()">
              <mat-icon>navigate_before</mat-icon>
            </button>
            <button mat-icon-button (click)="openSectionOverview()" aria-label="Open section list">
              <mat-icon title="Select section" >view_list</mat-icon>
            </button>
            <button title="Next section" mat-icon-button aria-label="Redo" (click)="nextSection()">
              <mat-icon>navigate_next</mat-icon>
            </button>
          </div>          
        </div>    
      </div>
      <h2 class="questionnaire-section-title canvas">{{ selectedSection.questionTitle }}</h2>
      <div class="questionnaire-last-saved" [ngClass]="{'questionnaire-animation': animate}" (animationend)="onAnimationEnd()" *ngIf="lastSaveTime">
          Last saved at: {{ lastSaveTime }}
        </div>
      <div class="questionnaire-section-content">
        <div class="questionnaire-flex-layout">
          <!-- First Column: Display Selected Section Content -->
          <div class="questionnaire-column">            
            <div class="header-with-actions">
              <h2>Instructions</h2>
              <span class="spacer"></span>
              <!--<button title="Previous section" mat-icon-button aria-label="Undo" (click)="previousSection()">
                <mat-icon>navigate_before</mat-icon>
              </button>
              <button mat-icon-button (click)="openSectionOverview()" aria-label="Open section list">
                <mat-icon title="Select section" >view_list</mat-icon>
              </button>
              <button title="Next section" mat-icon-button aria-label="Redo" (click)="nextSection()">
                <mat-icon>navigate_next</mat-icon>
              </button>-->
            </div>
            <p [innerHTML]="selectedSection.description"></p>
            <p [innerHTML]="selectedSection.example"></p>
          </div>
      
          <!-- Second Column: Long Text Input Field -->
          <div class="questionnaire-column">
            <div class="header-with-actions">
              <h2>Your input</h2>
              <span class="spacer"></span>
              <button title="Undo" mat-icon-button aria-label="Undo" (click)="undo()">
                <mat-icon>undo</mat-icon>
              </button>
              <button title="Redo" mat-icon-button aria-label="Redo" (click)="redo()">
                <mat-icon>redo</mat-icon>
              </button>
            </div>
          
            <mat-form-field appearance="fill" class="full-width">
              <!--<mat-label>Explain in as much detail as possible your answer</mat-label>-->
              <textarea matInput rows="30" class="custom-textarea" [(ngModel)]="selectedSection.answer" (input)="onInputChange()"></textarea>
            </mat-form-field>
          </div>
      
          <!-- Third Column: Backend Text Display -->
          <div class="questionnaire-column">            
            <div class="header-with-actions">
              <h2>AI assistant recommendation</h2>
              <span class="spacer"></span>              
              <button title="Get recommendations"                      
                      mat-icon-button
                      aria-label="get-recommendations"
                      (click)="getRecommendations()"
                      [disabled]="recommendationsLoading">
                
                <mat-icon *ngIf="!recommendationsLoading">auto_awesome</mat-icon>
                
                <mat-progress-spinner *ngIf="recommendationsLoading"
                                      class="spinner-icon"
                                      mode="indeterminate"
                                      diameter="24"
                                      strokeWidth="3"
                                      color="primary">
                </mat-progress-spinner>
              </button>
            </div>
            <p [innerHTML]="selectedSection.recommendations"></p>
          </div>
        </div>
      </div>
    </ng-template>    
  </div>